import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import { IApiJsonResponse } from '../../../__core/Interfaces/IApiResponse';
import { ICourse } from '../../../__core/Interfaces/ICourse';
import { httpGetWithDispatch } from '../../../__core/Providers/HttpClient/HttpCallerWithDispatch';
import {
  clearCourseDetails,
  getCourseDetailsSuccess,
  getCourseInstanceSuccess,
  getCourseProgressSuccess,
} from './ActionsCreators';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { CourseProgressResponse } from '../Types/CourseProgressResponse';
import HttpClient from '../../../__core/Providers/HttpClient/HttpClientInstance';

export function fetchCourseInstance(
  values: Record<string, unknown> | null
): ReduxAction<Promise<unknown>> {
  const url = 'course_instance';

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    const successDispatch = (response: unknown): void => {
      dispatch(
        getCourseInstanceSuccess(response as IApiJsonResponse<ICourseInstance>)
      );
    };

    return httpGetWithDispatch(dispatch, url, values, successDispatch);
  };
}

export function fetchCourseDetails(
  signature: string,
  hasDetails = false
): ReduxAction<Promise<unknown>> {
  const url = `course/${signature}${hasDetails ? '/details' : ''}`;

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    const successDispatch = (response: unknown): void => {
      dispatch(getCourseDetailsSuccess(response as IApiJsonResponse<ICourse>));
    };

    return httpGetWithDispatch(dispatch, url, null, successDispatch);
  };
}

export function fetchCourseProgress(
  signature: string
): ReduxAction<Promise<unknown>> {
  const url = `course/${signature}/progress`;

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    const successDispatch = (response: unknown): void => {
      dispatch(getCourseProgressSuccess(response as CourseProgressResponse));
    };

    return httpGetWithDispatch(dispatch, url, null, successDispatch);
  };
}

export function searchInMaterials(params: string): Promise<unknown> {
  const url = `material/search?${params}`;

  return new Promise<unknown>((resolve, reject) => {
    HttpClient.get(url).then(resolve).catch(reject);
  });
}

export function clearCourseData(): ReduxAction<void> {
  return (dispatch: ReduxDispatch): void => {
    dispatch(clearCourseDetails());
  };
}
